export enum PreferredLanguage {
  Bokmal = 'nb',
  Nynorsk = 'nn',
}

export const defaultLanguage = PreferredLanguage.Bokmal
